import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=edfe4496&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=edfe4496&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edfe4496",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('edfe4496')) {
      api.createRecord('edfe4496', component.options)
    } else {
      api.reload('edfe4496', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=edfe4496&scoped=true&", function () {
      api.rerender('edfe4496', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ZXIQf7zW9EWH/JS/comp/GuestBox.vue"
export default component.exports